import { render, staticRenderFns } from "./twoIndex.vue?vue&type=template&id=3ea5a8d1&scoped=true&"
import script from "./twoIndex.vue?vue&type=script&lang=js&"
export * from "./twoIndex.vue?vue&type=script&lang=js&"
import style0 from "./twoIndex.vue?vue&type=style&index=0&id=3ea5a8d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea5a8d1",
  null
  
)

export default component.exports